// errors/PermissionsNotSetError.ts
import { BaseError } from "@adornis/validation/errors/BaseError";
var PermissionsNotSetError = class extends BaseError {
  constructor(entityClass, extensions = {}) {
    if (!extensions.translationKey)
      extensions.translationKey = "baseql_permissionsNotSet";
    extensions.entityClass = entityClass;
    super(
      `No entityPermissions for ${entityClass} (or its parent classes) are set on the context, so baseql cannot determine if this operation is permitted.
    Please setup entityPermissions for ${entityClass} or any parent of it in your contextFactory.`,
      extensions
    );
  }
  static createFromDetails(message, extensions) {
    return new this(extensions.entityClass, extensions);
  }
};
PermissionsNotSetError._class = "PermissionsNotSetError";
export {
  PermissionsNotSetError
};
